<template>
  <v-row>
    <v-col>
      <general-error v-if="!!generalError && !dialogOpened" />
      <v-progress-linear :active="loading" color="loader" indeterminate />
      <v-row>
        <v-col cols="12" class="text-right">
          <btn-icon-tip
              icon="edit"
              icon-color="primary"
              :tip="$t('Редактирование шаблона')"
              @click="openEditLotDialog" />
        </v-col>
      </v-row>
      <lot-template-info-view
          :lot-template="lotTemplate"
          positions
          show-incoterms>
        <template v-slot:positions>
          <positions-template-list
              v-if="lotTemplate.lotTemplateId"
              :positions="positions"
              :lot-template="lotTemplate"
              :loading="loading"
              @change="change" />
        </template>
      </lot-template-info-view>
      <edit-lot-template-dialog
          v-if="editLotTemplateDialog.show"
          :dialog-prop="editLotTemplateDialog"
          @close="closeDialog('editLotTemplateDialog')" />
    </v-col>
  </v-row>
</template>

<script>
  import PositionsTemplateList from '@/components/pages/shared/PositionTemplate/PositionsTemplateList.vue'
  import LotTemplateInfoView from '@/components/pages/shared/LotTemplate/LotTemplateInfoView.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import EditLotTemplateDialog from '@/components/pages/shared/LotTemplate/EditLotTemplateDialog.vue'

  export default {
    components: {
      LotTemplateInfoView,
      PositionsTemplateList,
      GeneralError,
      EditLotTemplateDialog,
      BtnIconTip
    },
    props: {
      lotTemplate: {
        type: Object,
        default: () => {
          return {}
        }
      },
      positions: {
        type: Array,
        default: () => {
          return []
        }
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        editLotTemplateDialog: {
          show: false,
          lotTemplate: null,
          callback: null
        }
      }
    },
    computed: {
      dialogOpened () {
        return this.editLotTemplateDialog.show
      }
    },
    methods: {
      openEditLotDialog: function () {
        this.editLotTemplateDialog.lotTemplate = this.lotTemplate
        this.editLotTemplateDialog.callback = this.change
        this.editLotTemplateDialog.show = true
      },
      change: function () {
        this.$emit('change')
      }
    }
  }
</script>
